<!--
 * @Description: 医院列表页面
 * @Author: gaohc sunhuihong
 * @Date: 2022-03-16 16:43:52
 * @LastEditTime: 2023-02-21 16:36:20
-->
<template>
  <div class="body">
    <el-row class="bk-search" style="margin: 25px 40px" :gutter="0" type="flex" justify="space-between" align="middle">
      <el-col :span="6" style="text-align: left">
        <span class="search-title">医院名称：</span>
        <el-select size="small" style="width: 180px" placeholder="请输入/选择"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'hospitalList',
						srcHospitalList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
						visible, 'hospitalList', srcHospitalList, this)"
          clearable v-model="filterParams.hospitalId" filterable>
          <el-option v-for="item in hospitalList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" style="text-align: left">
        <span class="search-title">所属地区：</span>
        <el-cascader size="small" style="width: 187px" v-model="searchArea" clearable filterable
          placeholder="请输入/选择" :options="provinceList" :props="{checkStrictly: true,
					expandTrigger: 'hover', children: 'subRegionList', label: 'name', value: 'id'}">
        </el-cascader>
      </el-col>
      <el-col :span="6" style="text-align: left">
        <span class="search-title">机构名称：</span>
        <el-select size="small" style="width: 180px" v-model="filterParams.institutionId"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList',
						srcInstitutionList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
						visible, 'institutionList', srcInstitutionList, this)"
          filterable placeholder="请输入/选择" clearable @change="handelChangeInst">
          <el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="text-align: right">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search" style="width: 80px;">
          搜 索
        </el-button>
        <el-button size="small" v-if="dataPvgList.includes('HSP_1_CREATE')" @click="handleAddHospital"
          type="primary" icon="el-icon-plus" style="width: 80px;">
          新 增
        </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 25px 40px; border: 1px solid #f0f0f0" :style="tableWidth"
      ref="table" :data="dataTable" header-cell-class-name="table-header-color"
      row-key="id" :default-sort="{ prop: 'date', order: 'descending' }">
      <el-table-column label="医院logo" min-width="8%" align="left">
        <template slot-scope="scope">
          <img class="hspLogo" alt="" :src="loadHspLogo(scope.row.logoPath)" />
        </template>
      </el-table-column>
      <el-table-column label="医院编号" min-width="12%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">{{scope.row.identifier}}</span>
        </template>
      </el-table-column>
      <el-table-column label="医院名称" min-width="13%" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="所在地区" min-width="12%" align="left">
        <template slot-scope="scope">
          {{ scope.row.province ? scope.row.province + "/" : "-" }}
          {{ scope.row.city ? scope.row.city + "/" : "-" }}
					{{ scope.row.county ? scope.row.county : "" }}
        </template>
      </el-table-column>
      <el-table-column label="等级" min-width="10%" align="left">
        <template slot-scope="scope">
          {{ scope.row.gradeText ? scope.row.gradeText : "- -" }}
        </template>
      </el-table-column>
      <el-table-column label="签约机构" min-width="17%" align="left">
        <template slot-scope="scope">
          <div v-if="scope.row.simpleInstitutionList && scope.row.simpleInstitutionList.length < 4">
            {{ getSimpleInstitution(scope.row.simpleInstitutionList) }}
          </div>
          <el-popover v-else placement="right" trigger="hover">
              <div slot="reference">
                <span style="cursor: pointer">
                  {{ getSimpleInstitution(scope.row.simpleInstitutionList.slice(0, 3)) }}
                </span>
                <span>...</span>
              </div>
              <div v-for="(i, idx) in scope.row.simpleInstitutionList" :key="idx" style="line-height: 18px">
                <div style="margin-bottom: 5px;">{{ i.name }}</div>
              </div>
            </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="创建人" min-width="10%" align="left">
        <template slot-scope="scope">
          {{ scope.row.createrName ? scope.row.createrName : '- -' }}
        </template>
      </el-table-column>
      <el-table-column label="启用状态" min-width="10%" align="left">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.status && scope.row.hasBindinginst" class="item" effect="dark"
            content="禁用后，患者将无法查看该医院与相关服务" placement="top-start">
            <el-switch v-model="scope.row.status" :disabled="!dataPvgList.includes('HSP_4_STATUS_CHG')"
              active-color="#13ce66" :active-value="1" :inactive-value="0"
              @change="handleStatusSwitch(scope.row)">
            </el-switch>
          </el-tooltip>
          <el-switch v-else v-model="scope.row.status" :disabled="!dataPvgList.includes('HSP_4_STATUS_CHG')"
            active-color="#13ce66" :active-value="1" :inactive-value="0"
            @change="handleStatusSwitch(scope.row)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="18%" align="left">
        <template slot-scope="scope">
          <el-button v-if="hspPrivilege.canSelect" @click="handleDetailClick(scope.row)"
            type="text" size="small">
            详情
          </el-button>
          <template v-if="dataPvgList.includes('HSP_2_UPDATE')">
            <el-divider direction="vertical"></el-divider>
            <el-button @click="handleEdit(scope.row)" type="text" size="small">
							编辑
						</el-button>
          </template>
          <template>
            <el-divider direction="vertical"></el-divider>
            <el-dropdown>
              <el-button type="text" size="small">更多</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="!hspPrivilege.showRelationAndCancelRealtion"
                  @click.native="handleAffiliateIns(scope.row)">
                  <span :style="{color: hspPrivilege.showRelationAndCancelRealtion ? '#3E7EF5' : ''}">
                    关联机构
                  </span>
                </el-dropdown-item>
                <el-dropdown-item :disabled="!dataPvgList.includes('HSP_3_HSVC_BINDING')"
                  @click.native="handleBindingservice(scope.row)">
                  <span :style="{color: dataPvgList.includes('HSP_3_HSVC_BINDING') ? '#3E7EF5' : ''}">
                    绑定服务
                  </span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="handleJumpDepartment(scope.row)">
                  科室管理
                </el-dropdown-item>
                <el-dropdown-item :disabled="!hspPrivilege.canSelectAdmin"
                  @click.native="handleJumpBkUser(scope.row)">
                  管理员
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.hasBindinginst"
                  :disabled="!hspPrivilege.showRelationAndCancelRealtion"
                  @click.native="handleCancelAffiliateIns(scope.row)">
                  <span :style="{color: hspPrivilege.showRelationAndCancelRealtion ? '#FF3434' : ''}">
                    取消关联
                  </span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber"/>
    </el-row>

		<!-- 医院详情dialog -->
    <hspital-details :visible="showHspDialog" :mode="dialogMode" :hspId="hspId"
      @close-dialog="closeHspDialog" :instId="filterParams.institutionId" />

    <!-- 关联机构 -->
    <affiliated-institutions-dialog :visible="showAffiliatesDialog" :hspId="hspId"
      @close-dialog="closeAffiliatesDialog">
		</affiliated-institutions-dialog>

    <!-- 取消关联机构 -->
    <cancel-affiliated-institutions-dialog :visible="showCancelAffiliatesDialog"
      :hspId="hspId" @close-dialog="closeCancelAffiliatesDialog">
    </cancel-affiliated-institutions-dialog>

    <!-- 绑定服务dialog -->
    <binding-hservice :visible="showBindingHserviceDialog" :hspId="hspId" 
      @close-dialog="closeBindingHserviceDialog"/>
  </div>
</template>

<script>
import Util from "@/global/Util.js";
import Constant from "@/global/Constant.js";
import BindingHservice from "./components/BindingHservice.vue"
import HspitalDetails from "./components/hospitalList/HospitalDetails.vue";
import AffiliatedInstitutions from "./components/hospitalList/AffiliatedInstitutions.vue";
import CancelAffiatedInstututions from "./components/hospitalList/CancelAffiatedInstututions.vue";

export default {
  name: "HospitalList",
  components: {
    "hspital-details": HspitalDetails,
    "affiliated-institutions-dialog": AffiliatedInstitutions,
    "cancel-affiliated-institutions-dialog": CancelAffiatedInstututions,
    "binding-hservice": BindingHservice
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        institutionId: null,
        hospitalId: null,
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,

      searchArea: [],
      provinceList: [],
      srcInstitutionList: [],
      institutionList: [],
      srcHospitalList: [],
      hospitalList: [],
      statusList: [],
      hspPrivilege: {},
      dataTable: [],

      //以下用于新增/修改机构对话框使用
      showHspDialog: false,
      dialogMode: "",
      hspId: 0, //当前选中机构ID,

      showAffiliatesDialog: false, //关联机构对话框显示变量

      showCancelAffiliatesDialog: false, //取消关联机构对话框显示变量

      showBindingHserviceDialog: false,//绑定服务对话框显示变量
    };
  },
  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    },

    loadHspLogo() {
      return (logoPath) => {
        return logoPath ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, logoPath)
          : require("@/assets/instmng/instlist/img-instmng-default.png");
      };
    },

    getSimpleInstitution() {
      return (insList) => {
        if (!insList.length) return "- -";

        return Util.getStrFromArray(insList, "name");
      };
    },
  },

  methods: {
    //获取查询过滤条件
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_HOSPITAL_LIST_FILTERDO).then(
          (result) => {
            if (result == null) {
              return;
            }

            this.institutionList = result.data.institutionList;
            this.srcInstitutionList = result.data.institutionList;
            this.provinceList = result.data.provinceList;
            this.srcHospitalList = result.data.hospitalList;
            this.hospitalList = result.data.hospitalList;

            if (this.$route.params.institutionId) {
              this.$set(this.filterParams, "institutionId", this.$route.params.institutionId);
            }
            resolve();
          })
      });
    },

    //获取当前用户医院操作的权限
    queryhspPrivilege() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_HOSPITAL_PRIVILEGE).then((result) => {
          if (result == null) {
            return;
          }
          resolve(result.data);
        })
      });
    },

	  // 获取医院列表
    listHospitals() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(this.filterParams,
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_ADMIN_HOSPITAL_LIST,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then((result) => {
          if (result == null) {
            return;
          }

          this.dataTable = result.data;
          this.totalNumber = result.totalNumber;
          resolve();
        })
      });
    },

    handleQuery() {
      this.filterParams.page = 1;
      if (this.searchArea.length) {
        this.filterParams.provinceId = this.searchArea[0] ? this.searchArea[0] : "";
        this.filterParams.cityId = this.searchArea[1] ? this.searchArea[1] : "";
        this.filterParams.countyId = this.searchArea[2] ? this.searchArea[2] : "";
      } else {
        this.filterParams.provinceId = "";
        this.filterParams.cityId = "";
        this.filterParams.countyId = "";
      }

      this.listHospitals();
    },

    //切换选择服务机构
    handelChangeInst(val){
      this.filterParams.hospitalId = null;
      this.queryHspListFromInstId(val);
    },

    //根据服务机构Id查询对应机构下的医院列表
    async queryHspListFromInstId(instId) {
      let data = await Util.queryHspListFromInstId(instId, this);
      this.hospitalList = data.hospitalList;
      this.srcHospitalList = data.hospitalList;
    },

    //新增机构
    handleAddHospital() {
      this.showHspDialog = true;
      this.dialogMode = "add";
      this.hspId = 0;
    },

    //详情
    handleDetailClick(item) {
      this.showHspDialog = true;
      this.dialogMode = "details";
      this.hspId = item.id;
    },

    //编辑
    handleEdit(item) {
      this.showHspDialog = true;
      this.dialogMode = "edit";
      this.hspId = item.id;
    },

    //启用状态改变
    handleStatusSwitch(item) {
      let status = item.status == 1 ? "enable" : "disable";
      let strMessage = item.status == 1 ? "确认是否启用？" : "确认是否停用？";
      this.$confirm(strMessage, "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      }).then(() => {
        let params = {
          id: item.id,
          status: status
        };
        let url = Constant.URL_UPDATE_HOSPITAL_STATUS;
        this.queryStatusChange('PUT', params, url);
      }).catch(() => {
        this.listHospitals();
      });
    },

    // 医院启用状态改变和删除医院逻辑通用
    queryStatusChange(methods, params, url) {
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: methods,
        url: url,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };

      this.vueRequest(requestData).then((result) => {
				if (result == null) {
            return;
          }

        this.listHospitals();
      });
    },

    //跳转科室列表
    handleJumpDepartment(item) {
      this.jumpAsidePage("/hspmng/deptlist", "deptlist", item.id);
    },

    //跳转管理员
    handleJumpBkUser(item) {
      this.jumpAsidePage("/usermng/bkuser", "bkuser", item.id);
    },

    //关闭医院dialog
    closeHspDialog(refresh, hspId) {
      this.showHspDialog = false;
      if (refresh) this.initView();
      if (this.dialogMode == "add" && refresh) this.showAddBkUserAlert(hspId);
    },

    //新增医院管理员dialog
    showAddBkUserAlert(hspId) {
      this.$confirm("医院信息保存成功，快去设置医院管理员吧~", "提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "success",
      }).then(() => {
        this.jumpAsidePage("/usermng/bkuser", "bkuser", hspId, "hspAdd");
			});
    },

    deleteHospital(id) {
      this.queryStatusChange("DELETE", {id: id}, Constant.URL_DELETE_HOSPITAL);
    },

    //关闭关联医院对话框
    closeAffiliatesDialog(refresh) {
      if (refresh) {
        this.initView();
      } else {
        this.showAffiliatesDialog = false;
      }
    },

    handleAffiliateIns(item) {
      if (!item.status) {
        this.$message.warning("请先启用该医院再进行关联机构");
        return;
      }

      this.hspId = item.id;
      this.showAffiliatesDialog = true;
    },

    //关闭取消关联医院对话框
    closeCancelAffiliatesDialog(refresh) {
      this.showCancelAffiliatesDialog = false;
      if (refresh) this.initView();
    },

    //绑定服务
    handleBindingservice(item) {
      this.hspId = item.id;
      this.showBindingHserviceDialog = true;
    },

     //关闭取消绑定服务弹框
    closeBindingHserviceDialog(refresh) {
      this.showBindingHserviceDialog = false;
      if (refresh) this.initView();
    },

    handleCancelAffiliateIns(item) {
      this.hspId = item.id;
      this.showCancelAffiliatesDialog = true;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listHospitals();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listHospitals();
    },

    //跳转左边aside页面
    jumpAsidePage(_url, name, id, type) {
      let param = {
        hospitalId: id,
      };
      if (type) param.type = type;
      this.$router.push({
        name: name,
        params: param,
      });
    },

    rebuildDate(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'HSP'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    async initView() {
      await this.getDataPvg4CurRole();
      this.filterParams.institutionId = this.$route.params.institutionId;
      this.hspPrivilege = await this.queryhspPrivilege();
      await this.getFilterDo();
      await this.listHospitals();
    },
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "医院管理", text2: "医院列表" });
    this.initView();
  },
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.foot-pagination {
  margin-top: 20px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}

.hspLogo {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

.overflow-text-style {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/hspmng/HospitalList.vue